import {
  DEFAULT_UNAUTHORIZED_MODE,
  PERMISSIONS,
  filterMenuByPermission,
  hasPermission,
} from '@aimsos/people-access/permissions';

/**
 * Settings menu entries that depend on a permission (CT-5569). Entries not listed here are
 * not gated. The permission key is a placeholder (contract TBD, ARP/backend).
 */
const ITEM_PERMISSIONS = Object.freeze({
  'people-access': PERMISSIONS.MEMBERS_VIEW,
});

/**
 * Applies the viewer's permissions to the Settings menu sections: a gated entry the actor may
 * not use is removed (mode `hide`, the default), and a section left empty goes with it. With
 * no actor yet (still loading, or the request failed) nothing gated is granted.
 *
 * @param {Array<{ id: string, items: Array<{ id: string }> }>} sections
 * @param {{ user_type: string, permissions: string[] }|null} actor
 * @param {{ mode?: 'hide'|'lock' }} [options] Mode override (defaults to the app-wide mode).
 */
export const applySettingsPermissions = (sections, actor, { mode = DEFAULT_UNAUTHORIZED_MODE } = {}) =>
  filterMenuByPermission(
    sections.map((section) => ({
      ...section,
      items: section.items.map((item) =>
        ITEM_PERMISSIONS[item.id] ? { ...item, permission: ITEM_PERMISSIONS[item.id] } : item,
      ),
    })),
    (key) => ({ allowed: hasPermission(actor, key), mode }),
  );
